module.exports = __webpack_public_path__ + "img/bici.fe94d17d.svg";